import React, { useRef } from 'react';
import { useMutation } from '@apollo/client';
import TrackerExtractIngredientsMutation from './TrackerExtractIngredientsMutation';

interface ITrackerExtractIngredientsConnectorApolloProps {
  children: ({
    extractIngredients,
    cancelExtractIngredients,
  }: {
    extractIngredients: (input: any) => Promise<any>;
    cancelExtractIngredients: () => void;
  }) => React.ReactElement;
}

const TrackerExtractIngredientsConnectorApollo: React.FC<
  ITrackerExtractIngredientsConnectorApolloProps
> = ({ children }) => {
  const [extractIngredientsMutation] = useMutation(TrackerExtractIngredientsMutation);
  const abortControllerRef = useRef<AbortController | null>(null);

  const extractIngredients = async (input: any) => {
    // Create new AbortController for this request
    abortControllerRef.current = new AbortController();

    const response = await extractIngredientsMutation({
      variables: { input },
      context: {
        fetchOptions: {
          signal: abortControllerRef.current.signal,
        },
      },
    });

    return response.data.dailyTracker.extractIngredients;
  };

  const cancelExtractIngredients = () => {
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
      abortControllerRef.current = null;
    }
  };

  return children({ extractIngredients, cancelExtractIngredients });
};

export default TrackerExtractIngredientsConnectorApollo;
